<template>
  <div>
    <see-profile-component />
    
  </div>
</template>

<script>
import SeeProfileComponent from "../../components/Team/SeeProfile.component.vue";
export default {
  components: { SeeProfileComponent },
  data() {
      return {
       
      }
    }
};
</script>
